<template>
    <div class="bg-white rounded-10 position-relative course-price-info-box px-3">
        <div class="price-info-loader-box">
            <img class="price-info-loader" src="/storage/circle-loader.gif">
        </div>

        <button 
            @click="$emit('browse-courses')" 
            type="button" 
            data-toggle="modal"
            data-target="#courses-modal" 
            class="btn text-white bg-secondary-color w-100"
        >
            {{ tra.browse_all_courses }}
        </button>

        <hr class="my-2">
        
        <div class="cost-heading d-flex justify-content-between align-items-center">
            <h5 class="font-weight-bold text-main-color mb-0">{{ tra.costs }}</h5>

            <div>
                <div 
                    v-if="dataObj.course?.sat_discount > 0"
                    class="offer-icon sat-discount position-absolute"
                >
                    {{ tra.sat_discount_label }} -{{ (dataObj.course?.sat_discount || 0) * 100 }}%
                </div>
                <div 
                    style="margin-left: -8px;" 
                    v-if="dataObj.course?.discount_obj?.total_discounts"
                    class="offer-icon institute-discount position-absolute"
                >
                    {{ tra.institute_discount }} -{{ formatNumber((dataObj.course?.discount_obj?.total_discounts || 0) * 100) }}%
                </div>
            </div>
        </div>
        
        <hr class="my-2">
    </div>
</template>

<script>
export default {
    name: 'PriceInfoHeader',
    props: {
        dataObj: Object,
        tra: Object,
        appName: String,
    },
    emits: ['browse-courses'],
    methods: {
        formatNumber(number) {
            if (typeof number !== 'number') return number;
            
            if ((number - number.toFixed(1)).toFixed(2) == 0) {
                return number.toFixed();
            } else {
                return number.toFixed(1);
            }
        }
    }
};
</script>